module.exports = __webpack_public_path__ + "img/Winnie.95220c35.png";